import { FacetRenderer } from "../rendering/renderable/Renderable";
import { MeshRenderable } from "../rendering/mesh/MeshRenderable";
import { DelegateSubscription } from "flavr-common";
import { Quaternion as ThreeQuaternion } from "three";
import { Quaternion, Vector3 } from "flavr-math";
import { renderer } from "../rendering/RendererGlobals";
export class RotatingRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.objects = new Map();
        this.subscriptions = new DelegateSubscription();
        this.applyObjects = (mesh) => {
            var _a;
            if (this.facet === undefined)
                return;
            for (const param of this.facet.params) {
                const name = (_a = param.subObjectName) !== null && _a !== void 0 ? _a : "";
                if (this.objects.has(name))
                    continue;
                let obj;
                if (!name) {
                    obj = mesh.meshInstance.group;
                }
                else {
                    obj = mesh.meshInstance.findSubObjectByName(name);
                }
                if (obj === undefined)
                    continue;
                this.objects.set(name, {
                    obj,
                    angularVelocity: new Vector3().fromArray(param.angularVelocity),
                    initialQuaternion: obj.quaternion.clone()
                });
            }
            if (this.objects.size > 0) {
                this.registerAnimationCallback(this.update);
                // ToDo: Disable if not needed
                renderer.shadowMap.autoUpdate = true;
            }
        };
        this.update = (dt) => {
            if (this.facet === undefined)
                return;
            for (const data of this.objects.values()) {
                data.obj.rotation.x += data.angularVelocity.x * dt;
                data.obj.rotation.y += data.angularVelocity.y * dt;
                data.obj.rotation.z += data.angularVelocity.z * dt;
                data.obj.updateMatrix();
                data.obj.matrixWorldNeedsUpdate = true;
            }
        };
    }
    destroy() {
        this.unregisterAnimationCallback();
        this.subscriptions.removeAll();
    }
    setVisible() { }
    updateFacet() {
        this.objects.clear();
        const mesh = this.owner.getRenderableByType(MeshRenderable);
        if (!mesh)
            return;
        if (mesh.meshInstance.isLoaded) {
            this.applyObjects(mesh);
        }
        else {
            mesh.onLoadedDelegate.add(this.applyObjects, this.subscriptions);
        }
    }
    updateTransform() { }
    /** Returns the rotation accumulated since this renderable was initialized, for the first registered object. */
    getAccumulatedRotation() {
        for (const data of this.objects.values()) {
            const q = data.obj.quaternion;
            const qInvInitial = data.initialQuaternion.clone().invert();
            const accumulated = new ThreeQuaternion()
                .copy(q)
                .multiply(qInvInitial);
            return new Quaternion(accumulated.x, accumulated.y, accumulated.z, accumulated.w);
        }
        return new Quaternion();
    }
}
